export default "__VITE_ASSET__BnEnfkaL__"